import React, { ReactNode } from 'react';
import UnknownError from './UnknownError';

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface UnexpectedErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, UnexpectedErrorBoundaryState> {

    constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError(error: Error): { hasError: boolean; error: Error; } {
        return {
            hasError: true,
            error,
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.error(error, errorInfo);
    }

    clearError(): void {
        this.setState({
            hasError: false,
        });
    }

    render(): ReactNode {
        if (this.state.hasError) {
            return <UnknownError clearError={(): void => { this.clearError(); }} />;
        }

        return this.props.children;
    }

}

export default ErrorBoundary;
